<div class="multi-table">
	<data-table *ngFor="let table of tableData" [tableData]="table"
			[isEntitySelected]="isEntitySelected"
			[showSkeleton]="showSkeleton"
			[showLoading]="showLoading" [isLocationSelected]="isLocationSelected"
			[malfunctionsTableDialogData]="malfunctionsTableDialogData" [pageSizeOptions]="pageSizeOptions"
			(divisionClick)="divisionClicked($event)" (driverClick)="driverClicked($event)">
	</data-table>
</div>
